import { defaultEmployerFormValues, EmployerFormValues } from "../common/EmployerFormValues";
import { defaultAccidentFormValues, AccidentFormValues } from "./AccidentFormValues";
import { Taxation } from "../enums/Taxation";

export type AccidentEmployerFormValues = EmployerFormValues & AccidentFormValues
    & {
    hoursWorkedPerWeek: string,
    employeeContributionPercentage: string,
    premiumTaxation: Taxation
    accidentEmployeeContributionPercentage: string,
    accidentPremiumTaxation: Taxation
}

export const defaultAccidentEmployerFormValues = {
    ...defaultEmployerFormValues,
    ...defaultAccidentFormValues,
    hoursWorkedPerWeek: '',
    employeeContributionPercentage: '',
    premiumTaxation: '',
    accidentEmployeeContributionPercentage: '',
    accidentPremiumTaxation: ''
}